import { createReducer } from '@reduxjs/toolkit';
import { loadFormData, setUseRefDataInDispatch } from "../../actions/form";
export const defaultAppReducerConfig = {
  [loadFormData]: (state, action) => {
    const {
      app
    } = action.payload;
    return app;
  },
  [setUseRefDataInDispatch]: (state, action) => {
    const {
      useReferenceDataInDispatch
    } = action.payload;
    return {
      ...state,
      use_reference_data_in_dispatch_manager: useReferenceDataInDispatch
    };
  }
};
export const appReducer = createReducer({}, defaultAppReducerConfig);